<template>
  <div class="header flex justify-end" >
    <div class="flex align-center">
      <div style="color: #fff;">{{ serverTime }}</div>
      <Dropdown :avatar="require('@/assets/icon-notification-bing.svg')">
        <div class="notice">
          <div class="notice-title flex align-center justify-between">
            <div>{{ $t('Common.NOTIFICATION') }}</div>
            <div class="all" @click="$router.push('/notification')"> View All </div>
          </div>
          <div class="notice-item" v-for="(item, index) in noticeList" :key="index">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-time">{{ item.createTime }}</div>
          </div>
        </div>
      </Dropdown>
      <Dropdown :avatar="require('@/assets/avatar-layouts-5.png')" style="margin: 0;">
        <ul>
          <li v-for="item in list" :key="item.value" @click="onClickMenu(item)">
            <img :src="item.src" alt="">
            <span>{{ item.label }}</span>
          </li>

          <div class="divider"></div>

          <li class="logout" @click="onLogout">
            <img src="@/assets/icon-logout.svg" alt="">
            <span>{{ $t('Common.退出登录') }}</span>
          </li>
        </ul>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import SwitchLang from "@/components/switchLang.vue";
import { webUserGetServeTime } from "@/api";
import dayjs from "dayjs";
import Dropdown from "@/components/dropdown.vue";
import { getNoticeList } from "@/api/index";

export default {
  components: {
    SwitchLang,
    Dropdown
  },
  data() {
    return {
      lang: localStorage.getItem("lang") || "en-US",
      serverTime: "",
      currentTime: "",
      winStatus: window.innerWidth > 768,
      list: [
        { label: this.$t('Common.Profile'), value: "profile", path:'/profile', src: require('@/assets/icon-user.svg') },
        { label: this.$t('Common.Settings'), value: "settings", path: '/setting', src: require('@/assets/icon-sun.svg') }
      ],
      noticeList: []
    };
  },
  computed: {
    getUserInfo() {
      return this.$store.state.UserInfo;
    },
    getUserName() {
      return this.getUserInfo.userName;
    },
    getUserLevel() {
      return this.getUserInfo.userLevel;
    },
    getLevelName() {
      let name = "";
      if (this.getUserLevel) {
        name = this.$t("level." + this.getUserLevel);
      }
      return name;
    },
  },
  methods: {
    onLogout() {
      localStorage.removeItem('token');
      this.$router.replace('/login');
    },
    switchLang(value) {
      localStorage.setItem("lang", value);
      this.lang = value;
      window.location.reload();
    },
    getCurrentTime() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.currentTime += 1000;
          this.serverTime = dayjs(this.currentTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          const token = localStorage.getItem("token");
          if (!token) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async getServeTime() {
      const { data } = await webUserGetServeTime({});
      if (data.code === 20000) {
        // // console.log("webUserGetServeTime :>> ", data.data);
        this.serverTime = data.data;
        this.currentTime = new Date(data.data).getTime();
        this.getCurrentTime();

        setTimeout(() => {
          const token = localStorage.getItem("token");
          if (token) {
            this.getServeTime();
          }
        }, 30 * 60 * 1000);
      }
    },
    onClickMenu({ label, path }) {
      if(path === 'logout') {
        this.onLogout();
      } else {
        this.$store.commit('SET_StorePageTitle', label);
        this.$router.push(path);
      }
    },

    async getNoticeData(searchData = {}) {
      let _query = {
        pageSize: 10,
        page: 1
      };
      const { data } = await getNoticeList(_query);
      console.log("getNoticeList :>> ", data.data.records);
      if (data.code === 20000) {
        let { total, records } = data.data;
        let lang = localStorage.getItem("lang") || "en-US";
        this.noticeList = records.filter(item=> item.languageHeader === lang);
        // this.totalSize = total;
      }
    },
  },
  created() {
    this.getServeTime();
    this.getNoticeData();
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 100px;
}

.notice {
  color: #fff;

  .notice-title {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid var(--color-border);

    .all {
      color: var(--primary);
      font-size: 12px;
    }
  }

  .notice-item {
    padding: 10px;
    border-bottom: 1px solid var(--color-border);

    &:last-child {
      border: none;
    }

    &:hover {
      background: #0f0f12;
    }

    .item-title {
      line-height: 25px;
    }

    .item-time {
      color: #8B8B9A;
      line-height: 25px;
    }
  }
}

/* 菜单项 */
ul {
  padding: 15px 0;
  list-style: none;
  margin: 0;
}

li {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  color: var(--gray);
  font-size: 14px;
  border-radius: 10px;
}

li img {
  margin-right: 10px;
  height: 20px;
}

li:hover {
  background: #0f0f12;
  color: #fff;
}

/* 分割线 */
.divider {
  height: 1px;
  background: #eee;
  margin: 6px 0;
}

/* 登出 */
.logout {
  color: #666;
}

</style>
